import { render, staticRenderFns } from "./ModalFollowupWebCheckout.vue?vue&type=template&id=5adc104c&scoped=true&"
import script from "./ModalFollowupWebCheckout.vue?vue&type=script&lang=js&"
export * from "./ModalFollowupWebCheckout.vue?vue&type=script&lang=js&"
import style0 from "./ModalFollowupWebCheckout.vue?vue&type=style&index=0&id=5adc104c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adc104c",
  null
  
)

export default component.exports